import './style/index.js';

import _InputNumber from './InputNumber';

export type { InputNumberProps } from './InputNumber';
export * from './type';

export const InputNumber = _InputNumber;
export default InputNumber;
